export default function AboutTheCompany() {
    return(<div>
        <div>
            About the Company
        </div>
    </div>)
}